import { useState } from 'react'
import { Box } from '@mui/material'

import ImageGalleryModal from 'src/components/image-gallery-modal'
import { IMedia } from 'src/types'

interface IProps {
  media: Pick<IMedia, 'link' | 'link_medium' | 'title' | 'id'>[]
}

export const MediaList = ({ media }: IProps) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [startIndex, setStartIndex] = useState(0)

  const handleImageClick = (index: number) => {
    setStartIndex(index)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px', flexWrap: 'wrap' }}>
        {media.map((image, index) => (
          <Box key={image.id} sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}>
            <img
              src={image.link_medium || image.link}
              alt={image.title}
              style={{ height: '120px', width: 'auto' }}
              onClick={() => handleImageClick(index)}
            />
          </Box>
        ))}
      </Box>
      <ImageGalleryModal
        open={modalOpen}
        handleClose={handleCloseModal}
        images={media}
        startIndex={startIndex}
      />
    </>
  )
}
